import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import P1 from '@base/P1/P1';
import { Fonts, Spacings } from '@styles/index';
import CardHeader from './CardHeader';
import Card from './Card';

const StyledCard = styled(Card)`
  margin-top: ${Spacings.SPACING_4B};
`;

const StyledP2 = styled(P2)`
  font-size: ${Fonts.EXTRA_SMALL};
`;

const NewTitleWrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
`;

const CourseEditCard = ({ story }) => {
  const { message, created_at, object } = story;

  return (
    <div>
      <CardHeader
        message={message}
        img="course-edit-icon.svg"
        created_at={created_at}
      />
      <StyledCard>
        <div>
          <StyledP2>OLD TITLE</StyledP2>
          <P1>{object.old_title}</P1>
        </div>
        <NewTitleWrapper>
          <StyledP2>NEW TITLE</StyledP2>
          <P1>{object.new_title}</P1>
        </NewTitleWrapper>
      </StyledCard>
    </div>
  );
};

export default CourseEditCard;

CourseEditCard.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired
};
